import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useReceiptsOfUser = <TData = any, TError = any>(
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { bookingApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      bookingApiService.createCancellableRequest((cancelToken) =>
        bookingApiService.getReceiptsOfUser(cancelToken)
      ),
    [bookingApiService]
  );

  return useQuery(QueryKeys.receiptsOfUser(), queryFn, queryOptions);
};
